<template>
  <img src="@/assets/img/Icons/Propane.svg" />
</template>

<script>
export default {}
</script>

<style></style>
